import React, { useState, useEffect } from 'react'
import { SimplifiedTeamBrowser } from './SimplifiedTeamBrowser'
import { MobileTeamBrowser } from './MobileTeamBrowser'

interface UnifiedTeamBrowserProps {
  className?: string
}

export function UnifiedTeamBrowser({ className }: UnifiedTeamBrowserProps) {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      // Use tablet breakpoint (768px) for better responsive experience
      setIsMobile(window.innerWidth < 768)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  // For now, let's use the simplified desktop version for all screen sizes
  // This gives us a consistent, clean experience
  return (
    <div className={className}>
      <SimplifiedTeamBrowser />
    </div>
  )
}

// Export as default for easy replacement
export default UnifiedTeamBrowser